<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>dashboard_customize</mat-icon>
      Topic Areas
    </h2>
    <div class="section-header-actions">
      <button mat-stroked-button color="primary" (click)="refreshAll()" [disabled]="isActionBusy(refreshActionKey()) || loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
      <button mat-flat-button color="primary" (click)="openCreateTopicArea()">Create Topic Area</button>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <table class="admin-table" *ngIf="!loading">
    <thead>
      <tr>
        <th>ID</th>
        <th>Title</th>
        <th>Sequence</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of getPaginatedItems('topicAreas', topicAreas)">
        <td>{{ item.id }}</td>
        <td>{{ item.topic_area_title }}</td>
        <td>{{ item.sequence }}</td>
        <td>
          <button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="openEditTopicArea(item)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" type="button" matTooltip="Delete" [disabled]="isActionBusy(topicAreaDeleteActionKey(item.id))" (click)="deleteTopicArea(item)" class="delete-btn">
            <mat-spinner *ngIf="isActionBusy(topicAreaDeleteActionKey(item.id))" diameter="16" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(topicAreaDeleteActionKey(item.id))">delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pagination-row" *ngIf="topicAreas.length > 0 && !loading">
    <button mat-stroked-button type="button" (click)="goToPreviousPage('topicAreas')" [disabled]="getCurrentPage('topicAreas') === 1">Previous</button>
    <span>Page {{ getCurrentPage('topicAreas') }} of {{ getTotalPages('topicAreas', topicAreas.length) }}</span>
    <button mat-stroked-button type="button" (click)="goToNextPage('topicAreas', topicAreas.length)" [disabled]="getCurrentPage('topicAreas') >= getTotalPages('topicAreas', topicAreas.length)">Next</button>
  </div>

  <div class="modal-backdrop" *ngIf="isTopicAreaEditorVisible">
    <div class="modal-card mat-elevation-z8 editor-modal-card">
      <div class="modal-header">
        <div>
          <h3 class="editor-modal-title">
            <mat-icon>dashboard_customize</mat-icon>
            {{ editingTopicAreaId ? 'Edit Topic Area' : 'Create Topic Area' }}
            <span class="entity-id" *ngIf="editingTopicAreaId">ID: {{ editingTopicAreaId }}</span>
          </h3>
          <p class="editor-modal-subtitle">Manage topic area metadata and its topics in one dialog.</p>
        </div>
        <button mat-icon-button type="button" (click)="cancelTopicAreaEdit()" aria-label="Close topic area editor">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-body editor-modal-body">
        <div class="topic-area-editor-section">
          <div class="form-row material-grid">
            <mat-form-field appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput [(ngModel)]="topicAreaForm.topic_area_title" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Sequence</mat-label>
              <input matInput [(ngModel)]="topicAreaForm.sequence" type="number" />
            </mat-form-field>
          </div>

          <div class="demo-update-row">
            <button mat-flat-button color="primary" type="button" (click)="saveTopicArea()" [disabled]="isActionBusy(topicAreaSaveActionKey()) || (editingTopicAreaId && !isTopicAreaFormDirty)">
              <mat-spinner *ngIf="isActionBusy(topicAreaSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
              <span *ngIf="!isActionBusy(topicAreaSaveActionKey())">{{ editingTopicAreaId ? 'Update' : 'Create' }}</span>
            </button>
          </div>

          <div class="embedded-section" *ngIf="editingTopicAreaId">
            <div class="section-header">
              <h2>Topics</h2>
              <button mat-icon-button color="primary" type="button" aria-label="Create Topic" (click)="openCreateTopicForCurrentTopicArea()">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <table class="admin-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Sequence</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="isCreatingTopic()">
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Title</mat-label>
                      <input matInput [(ngModel)]="topicForm.topic_title" />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Sequence</mat-label>
                      <input matInput [(ngModel)]="topicForm.sequence" type="number" />
                    </mat-form-field>
                  </td>
                  <td>
                    <button mat-icon-button color="primary" type="button" matTooltip="Create" [disabled]="isActionBusy(topicSaveActionKey())" (click)="saveTopic()">
                      <mat-spinner *ngIf="isActionBusy(topicSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelTopicEdit()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>

                <tr *ngFor="let item of getPaginatedItems('topics', topicsForEditingTopicArea())">
                  <td *ngIf="!isEditingTopic(item)">{{ item.topic_title }}</td>
                  <td *ngIf="isEditingTopic(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Title</mat-label>
                      <input matInput [(ngModel)]="topicForm.topic_title" />
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingTopic(item)">{{ item.sequence }}</td>
                  <td *ngIf="isEditingTopic(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Sequence</mat-label>
                      <input matInput [(ngModel)]="topicForm.sequence" type="number" />
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingTopic(item)">
                    <button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="openEditTopic(item)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" type="button" matTooltip="Delete" [disabled]="isActionBusy(topicDeleteActionKey(item.id))" (click)="deleteTopic(item)" class="delete-btn">
                      <mat-spinner *ngIf="isActionBusy(topicDeleteActionKey(item.id))" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon *ngIf="!isActionBusy(topicDeleteActionKey(item.id))">delete</mat-icon>
                    </button>
                  </td>
                  <td *ngIf="isEditingTopic(item)">
                    <button mat-icon-button color="primary" type="button" matTooltip="Update" (click)="saveTopic()" [disabled]="isActionBusy(topicSaveActionKey()) || !isTopicFormDirty">
                      <mat-spinner *ngIf="isActionBusy(topicSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelTopicEdit()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="pagination-row" *ngIf="topicsForEditingTopicArea().length > 0">
              <button mat-stroked-button type="button" (click)="goToPreviousPage('topics')" [disabled]="getCurrentPage('topics') === 1">Previous</button>
              <span>Page {{ getCurrentPage('topics') }} of {{ getTotalPages('topics', topicsForEditingTopicArea().length) }}</span>
              <button mat-stroked-button type="button" (click)="goToNextPage('topics', topicsForEditingTopicArea().length)" [disabled]="getCurrentPage('topics') >= getTotalPages('topics', topicsForEditingTopicArea().length)">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
